import type { UserWithSettingsResponse } from '@lib/responses/user';
import {
  userCanEditQuote,
  userCanEditQuoteLine,
} from '@snap-types/features/user/has-minimum-role';
import { UserRole } from '@snap-types/models/enums';
import { useAuth } from '@ui/state/auth';

export type CurrentUser = UserWithSettingsResponse;

export function useCurrentUser(): {
  currentUser: CurrentUser;
  isSuperAdmin: boolean;
  canEditQuoteLine: boolean;
  canEditQuote: boolean;
} {
  const { user: currentUser } = useAuth();

  if (!currentUser) {
    throw new Error('Current user expected but missing!');
  }

  const isSuperAdmin = currentUser.role === UserRole.SUPERADMIN;
  const canEditQuoteLine = userCanEditQuoteLine(currentUser);
  const canEditQuote = userCanEditQuote(currentUser);
  return {
    currentUser,
    isSuperAdmin,
    canEditQuoteLine,
    canEditQuote,
  };
}
